/**
 * The Contract Insights overview tile for inspections: the contract's place in this round and the
 * car's condition, as get_contract_inspections' `current` states them, with the day of this contract's
 * last visit.
 */

import { ClipboardCheck } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { ATTENDANCE_LABEL, formatShortDay } from '@/lib/inspections';
import { useContractInspections } from './inspectionApi';

export default function InspectionStatusTile({ contractId }: { contractId: number }) {
    const { data, isLoading } = useContractInspections(contractId);
    const current = data?.current;
    // This contract's latest visit: an admin's payload lists every visit on the car, the next driver's
    // and between contracts included.
    const last = data?.visits.find((v) => v.contract_id === contractId) ?? null;

    let headline = '—';
    if (current) {
        if (current.condition === 'held') headline = `Held · ${current.open_fix_now ?? 0} must fix`;
        else if (current.attendance === 'presented') headline = `Presented ${formatShortDay(current.inspected_on)}${current.late ? ' (late)' : ''}`;
        else if (current.attendance) headline = ATTENDANCE_LABEL[current.attendance];
        else headline = current.period ? 'Not in this round' : 'No round yet';
    }

    return (
        <Card className="border border-border/40">
            <CardContent className="pt-6">
                <div className="space-y-1">
                    <p className="flex items-center gap-2 text-sm text-muted-foreground">
                        <ClipboardCheck className="h-4 w-4" />
                        Inspections
                    </p>
                    <p className="text-xl font-semibold">
                        {isLoading ? '…' : headline}
                        {last && <span className="ml-2 text-sm font-normal text-muted-foreground">(last: {formatShortDay(last.inspected_on)})</span>}
                    </p>
                </div>
            </CardContent>
        </Card>
    );
}
